<template>
  <div>
    <div
      class="f-field f-field--radiogroup f-field--inline"
      :class="{ 'f-field--required' : isRequired }"
    >
      <fieldset role="radiogroup">
        <legend

          class="f-field__label"
        >
          {{ $t(`fields.record.${fieldName}.label`) }}
        </legend>
        <div
          v-if="$te(`advancedsearch.fields.${fieldName}.description`)"
          class="f-field__tooltip"
        >
          <Tooltip>
            <p>
              {{ $t(`advancedsearch.fields.${fieldName}.description`) }}
            </p>
          </Tooltip>
        </div>
        <div class="f-field__options">
          <div class="f-field--radio f-field--sm">
            <input
              id="yes"
              v-model="checkboxValue"
              type="radio"
              :name="`radio-${fieldName}`"
              :value="true"
              class="f-field__input"
              @change="changeValue"
            >
            <label
              for="yes"
              class="f-field__label"
            >{{ $t(`fields.record.${fieldName}.values.yes`) }}</label>
          </div>
          <div class="f-field--radio f-field--sm">
            <input
              id="no"
              v-model="checkboxValue"
              type="radio"
              :name="`radio-${fieldName}`"
              :value="false"
              class="f-field__input"
              @change="changeValue"
            >
            <label
              for="no"
              class="f-field__label"
            >{{ $t(`fields.record.${fieldName}.values.no`) }}</label>
          </div>
        </div>
      </fieldset>
    </div>
  </div>
</template>

<script>
import Tooltip from '#src/components/utils/Tooltip.vue'

export default {
  components: {
    Tooltip
  },
  props: {
    modelValue: {
      type: Object,
      required: true
    },
    recordType: {
      type: String,
      required: true
    },
    fieldName: {
      type: String,
      required: true
    },
    isRequired: {
      type: Boolean,
      default: false
    }
  },
  emits: ['input', 'update:modelValue'],
  data() {
    return {
      checkboxValue: true
    }
  },
  async created() {
    if (this.modelValue.value === null) {
      this.modelValue.value = true
      this.$emit('input', this.value)
      this.$emit('update:modelValue', this.value)
    }
  },
  methods: {
    changeValue() {
      this.modelValue.value = this.checkboxValue
      this.$emit('input', this.modelValue)
      this.$emit('update:modelValue', this.modelValue)
    }
  }
}
</script>
